(function(){
  'use strict';
  var secs = document.querySelectorAll('.shopify-section');
  if (!secs.length) return;
  var fallbackTimer = setTimeout(function() {
    secs.forEach(function(el) { el.classList.add('lissea-in-view'); });
  }, 800);
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('lissea-in-view'); obs.unobserve(e.target); }
      });
      var allVisible = Array.prototype.every.call(secs, function(el) { return el.classList.contains('lissea-in-view'); });
      if (allVisible) clearTimeout(fallbackTimer);
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    secs.forEach(function(el, i) { if (i === 0) { el.classList.add('lissea-in-view'); } else { obs.observe(el); } });
  } else {
    clearTimeout(fallbackTimer);
    secs.forEach(function(el) { el.classList.add('lissea-in-view'); });
  }
  function injectSaving() {
    document.querySelectorAll('[ref="priceContainer"]').forEach(function(c) {
      if (c.querySelector('.lissea-saving-badge')) return;
      var cmp=c.querySelector('.compare-at-price'), prc=c.querySelector('.price-item--sale,.price');
      if (!cmp||!prc) return;
      function p(el){ return parseFloat((el.textContent||'').replace(/\s/g,'').replace(',','.').replace(/[^0-9\.]/g,''))||0; }
      var cv=p(cmp),pv=p(prc);
      if(cv>pv&&pv>0){ var pct=Math.round(((cv-pv)/cv)*100); if(pct>0&&pct<=85){ var b=document.createElement('span'); b.className='lissea-saving-badge'; b.textContent='-'+pct+'%'; cmp.after(b); } }
    });
  }
  injectSaving();
  document.addEventListener('variant:changed', injectSaving);
  var POP=['bundle','duo','kit','coffret','set','pack'];
  document.querySelectorAll('product-card,.product-card').forEach(function(card){
    var link=card.querySelector('a[href*="/products/"]');
    var h=((card.dataset.productHandle||(link&&link.getAttribute('href')||'').split('/products/')[1]||'').split('?')[0]).toLowerCase();
    if(POP.some(function(k){return h.includes(k);})&&!card.querySelector('.lissea-badge-popular')){
      var b=document.createElement('span'); b.className='lissea-badge-popular'; b.textContent='Le plus populaire';
      var ct=card.querySelector('.product-card__content'); (ct||card).style.position='relative'; (ct||card).prepend(b);
    }
  });
  function initCountdown(){
    var wrap=document.querySelector('.lissea-countdown__timer'); if(!wrap) return;
    var now=new Date(), end=new Date(now); end.setHours(23,59,0,0);
    if(now>=end) end.setDate(end.getDate()+1);
    function tick(){ var d=Math.max(0,end-Date.now()); var h=Math.floor(d/3600000),m=Math.floor((d%3600000)/60000),s=Math.floor((d%60000)/1000); wrap.textContent=String(h).padStart(2,'0')+'h '+String(m).padStart(2,'0')+'m '+String(s).padStart(2,'0')+'s'; if(d>0) setTimeout(tick,1000); }
    tick();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initCountdown); else initCountdown();
/* FAQ fallback Android — details/summary bugué sur certains Samsung/Chrome ancien */
  document.querySelectorAll('.lissea-faq__item').forEach(function(details){
    var summary = details.querySelector('.lissea-faq__q');
    if(!summary) return;
    summary.addEventListener('click', function(e){
      e.preventDefault();
      var isOpen = details.hasAttribute('open');
      document.querySelectorAll('.lissea-faq__item[open]').forEach(function(d){
        d.removeAttribute('open');
      });
      if(!isOpen) details.setAttribute('open','');
    });
  });})();